import React from "react";
import bag from "../../../../assets/Icons/dashboard/👜.png";
import { OrderStatusBadge } from "./order-status-badge";
import { OrdersActionsMenu } from "./orders-actions-menu";

export function OrdersOrderCard({ order, onViewDetails }) {
  const productImage = order.raw?.product?.images?.[0];
  const hasProductImage = Boolean(productImage);
  const image = productImage || bag;
  const categoryLabel =
    order.category && order.category !== "—" ? order.category : "Order";

  return (
    <article className="flex min-w-0 flex-col">
      <div
        role="button"
        tabIndex={0}
        onClick={() => onViewDetails?.(order)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onViewDetails?.(order);
          }
        }}
        className={`relative flex aspect-square h-[140px] cursor-pointer items-center justify-center overflow-hidden rounded-xl bg-[#F8F8F8] p-2.5 box-border sm:h-[160px] sm:p-3 ${
          hasProductImage ? "bg-cover bg-center" : ""
        }`}
        style={
          hasProductImage ? { backgroundImage: `url(${image})` } : undefined
        }
      >
        {!hasProductImage ? (
          <img
            src={bag}
            alt=""
            className="h-[72px] w-auto max-w-[80%] object-contain sm:h-[88px]"
          />
        ) : (
          <div
            className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-transparent"
            aria-hidden
          />
        )}
        <div className="absolute inset-0 z-[1] flex items-start justify-between gap-1 p-2.5 sm:p-3">
          <OrderStatusBadge status={order.status} />
          <div
            className="shrink-0 rounded-full bg-white/90 shadow-sm backdrop-blur-sm"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <OrdersActionsMenu order={order} onViewDetails={onViewDetails} />
          </div>
        </div>
      </div>
      <div className="mt-2.5 flex flex-col gap-1.5 sm:mt-3 sm:gap-2">
        <div className="flex items-start justify-between gap-1.5">
          <h3 className="my-0 line-clamp-2 text-[13px] font-bold leading-snug text-[#3D3D3D] sm:text-[14px]">
            {order.productName}
          </h3>
          <span className="shrink-0 text-[13px] font-bold text-[#111827] sm:text-[14px]">
            {order.price}
          </span>
        </div>
        <span className="flex h-[22px] w-fit max-w-full items-center justify-center truncate rounded-[9px] bg-[#F8F8F8] px-2 text-[11px] font-medium text-[#0088FF] sm:text-[12px]">
          {categoryLabel}
        </span>
      </div>
    </article>
  );
}
